import { RiFingerprintLine } from "@remixicon/react";

export function PasskeyIcon({ className }: { className?: string }) {
  return <RiFingerprintLine className={className} />;
}
